export default {
  HomeView: {
    test: 'Polski tekst',
  },
  stayDeclination: {
    single: 'day',
    few: 'days',
    multiple: 'days',
  },
  firstStep: {
    resort: {
      chosen: 'Wybrana lokalizacja',
      others: 'Inne lokalizacje',
    },
  },
  general: {
    test: 'test',
  },
}
